import { memo, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { debounce } from 'lodash-es'
import { Select, Input } from '@mantine/core'
import { Container } from './index'

const inspectTimeOptions = [
  {
    label: '晨检',
    value: '晨检',
  },
  {
    label: '日常检查',
    value: '日常检查',
  },
  {
    label: '夜检',
    value: '夜检',
  },
]

// 沈阳用
const Filter = ({ user, onChange }) => {
  const { control, watch } = useForm()

  useEffect(() => {
    const subscription = watch(
      debounce(onChange, 700, { leading: false, trailing: true })
    )
    return () => subscription.unsubscribe()
  }, [])
  if (!user) return null
  return (
    <Container className="absolute top-8 right-8 rounded-lg bg-white w-80">
      <form>
        <div className="flex flex-col gap-4 p-5 mb-2">
          <div className="text-sm text-gray-300">检查项</div>
          <Controller
            name="checkItem"
            control={control}
            render={({ field }) => (
              <Select
                placeholder="请选择检查项"
                data={inspectTimeOptions}
                clearable
                {...field}
              />
            )}
          />
          <div className="text-sm text-gray-300">区域</div>
          <Controller
            name="district"
            control={control}
            render={({ field }) => (
              <Input
                className="w-full"
                placeholder="请输入区域搜索"
                {...field}
              />
            )}
          />
        </div>
      </form>
    </Container>
  )
}

export default memo(Filter)
